/* Cart-drawer cross-sell: one-click add without leaving the drawer.
   Delegated at document level on purpose — Dawn replaces #CartDrawer's innerHTML on every cart
   change, which does not re-run inline scripts, so a listener bound to the markup would die. */
(function () {
  if (window.__cartCrossSellBound) return;
  window.__cartCrossSellBound = true;

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-cross-sell-add]');
    if (!button) return;
    event.preventDefault();

    const variantId = button.dataset.variantId;
    const cartDrawer = document.querySelector('cart-drawer');
    if (!variantId || !cartDrawer) return;

    const original = button.textContent;
    button.setAttribute('disabled', '');
    button.textContent = 'Adding…';

    const body = {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: cartDrawer.getSectionsToRender().map(function (s) { return s.id; }),
      sections_url: window.location.pathname,
    };

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    })
      .then(function (response) { return response.json(); })
      .then(function (parsed) {
        if (parsed.status) throw new Error(parsed.description || parsed.message || 'Add to cart failed');
        cartDrawer.renderContents(parsed);
      })
      .catch(function (error) {
        console.error('[cart-cross-sell]', error);
        button.removeAttribute('disabled');
        button.textContent = original;
      });
  });
})();
